import type { HTMLAttributes } from 'react';

interface StudentAvatarProps extends HTMLAttributes<SVGElement> {
  student: {
    firstName: string;
    lastName: string;
    bgColor: string;
  };
  radius?: number;
}

export const StudentAvatar = ({ student, radius = 8, ...props }: StudentAvatarProps) => {
  let initials = '?';
  if (student.firstName && student.lastName) {
    initials = `${student.firstName.charAt(0)}${student.lastName.charAt(0)}`.toUpperCase();
  }

  const color = student.bgColor || '#F2F2F2';

  return (
    <svg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg' aria-hidden='true' {...props}>
      <rect x='0' y='0' width='28' height='28' rx={radius} fill={color} />
      <text x='14' y='18.5' textAnchor='middle' fontFamily='Nunito Sans, Arial, sans-serif' fontSize='12' fill='#22223B'>
        {initials}
      </text>
    </svg>
  );
};
